var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('b-pagination-nav',{attrs:{"value":_vm.current,"number-of-pages":_vm.pages,"use-router":true,"link-gen":_vm.linkGen,"page-gen":_vm.pageGen,"align":_vm.align}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }